import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import debounce from 'lodash/debounce';

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  width: 100%;
  max-width: 400px;
  padding: 0.8rem 1.2rem;
  border: 1px solid #2C3E50;
  border-radius: 50px;
  font-size:0.8rem;
  color: #2C3E50;
  background-color: transparent;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #2C3E50;
    opacity: 1;
  }
`;

const SearchBar = ({ onChange }) => {
  const [inputValue, setInputValue] = useState('');
  
  // Debounce the search to prevent too many API calls
  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      onChange(searchTerm);
    }, 200),
    [onChange]
  );

  const handleChange = (e) => {
    const searchTerm = e.target.value;
    setInputValue(searchTerm);
    debouncedSearch(searchTerm);
  };

  return (
    <SearchContainer>
      <SearchInput
        type="text"
        placeholder="Search by company name or symbol (e.g., Apple, AAPL)..."
        value={inputValue}
        onChange={handleChange}
      />
    </SearchContainer>
  );
};

export default SearchBar; 